const getTomorrowsDate = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  return tomorrow;
};

export const parsePresentUnixDate = (unixTimestamp: string | null) => {
  if (!unixTimestamp || isNaN(Number(unixTimestamp))) {
    return null;
  }

  const timestamp = Number(unixTimestamp);

  if (timestamp <= 0 || timestamp > getTomorrowsDate().getTime() / 1000) {
    return null;
  }

  return new Date(timestamp * 1000);
};
